import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { checkFormatAllow } from "../../../common/util";
import ResetPwd from "./ResetPwd";
import { requests } from "common/RestAPI";
import { PLATFORM_URL } from "value/Url";

export default function ResetPwdContainer() {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const [tabIndex, setTabIndex] = useState(1);

    const [email, setEmail] = useState("");

    const [infoText, setInfoText] = useState("");
    const [infoError, setInfoError] = useState(false);

    const [resetPwdFnYn, setResetPwdFnYn] = useState(false);

    const [resetPwdResendYn, setResetPwdResendYn] = useState(false);

    useEffect(() => {
        if(tabIndex === 2) {
            setResetPwdFnYn(true);
        }
    }, [tabIndex])

    useEffect(() => {
        if(resetPwdFnYn) {
            sendEmailFn();
        }
    }, [resetPwdFnYn])

    useEffect(() => {
        if(resetPwdResendYn) {
            setResetPwdFnYn(true);

            setTimeout(() => {
                setResetPwdResendYn(false);
            }, 10000)
        }
    }, [resetPwdResendYn])



    function AlertFunction(text:string, error=false) {
        setInfoText(text);
        setInfoError(error);
    }

    function sendEmailFn() {
        requests.post(PLATFORM_URL.FIND_PSSWORD, {email: email})
        .then((response) => {

        })
        setTimeout(() => {
            setResetPwdFnYn(false);
        }, 5000);
    }

    function nextTabIndexFn() {
        if(!checkFormatAllow(email, ["email"])) {
            AlertFunction(t("EMAIL_FORMAT_ERROR"), true)
        }
        else {
            setTabIndex(tabIndex + 1);
        }
    }

    return (
        <ResetPwd
            tabIndex={tabIndex}
            nextTabIndexFn={nextTabIndexFn}
            email={email}
            setEmail={setEmail}
            infoText={infoText}
            infoError={infoError}
            resetPwdResendYn={resetPwdResendYn}
            setResetPwdResendYn={setResetPwdResendYn}
            navigate={navigate}
        />
    )
}